import {device} from "../../common/util"
import {CR} from "../enums";

/**
 * 定义原生响应超时时间，暂定5秒
 */
function timeout(time = 5000, fnName, params) {
    return new Promise((resolve, rejecet) => {
        setTimeout(rejecet.bind(this, new Error(`request jsBridge timeout: ${fnName} - ${JSON.stringify(params)}`)), time)
    })
}

const ua = navigator.userAgent
const isIOS = (/iPhone|iPad|iPod/i).test(ua)
const isAndroid = (/Android/i).test(ua)
const osVersion = ua.match(/(?:OS|Android)[\/\s](\d+[._]\d+(?:[._]\d+)?)/i)
const IS_APP_ENV = true;

const jsBridge = {
    ua,
    isIOS,
    isAndroid,
    osVersion,
    IS_APP_ENV,

    _callNative: function (fnName, params, duration = 15000) {
        return new Promise((resolve, reject) => {
            //console.log('fnName', fnName)
            const _fnName = fnName.split('/')
            const sClass = _fnName[0]
            const hybirdFn = _fnName.length > 1 ? _fnName[1] : _fnName[0]
            try {
                // console.log('WindVane resolve 数据: ', sClass, hybirdFn, params, device().isiOS,device().isAndroid)
                window.WindVane.call(sClass, hybirdFn, params, function (res) {
                    try{
                        console.warn('WindVane resolve: ', sClass, hybirdFn, JSON.parse(decodeURIComponent(params)), res)
                    } catch (err) {
                        console.warn('WindVane resolve: ', sClass, hybirdFn, params, res/*, err*/)
                    }
                    resolve(res)
                }, function (e) {
                    try{
                        console.warn('WindVane reject: ', sClass, hybirdFn, JSON.parse(decodeURIComponent(params)), e)
                    } catch (err) {
                        console.warn('WindVane reject: ', sClass, hybirdFn, params, e/*, err*/)
                    }
                    reject(e)
                }, duration)
            } catch (e) {
                console.warn('WindVane.call Exception: ', e)
            }
        })
    },
    /**
     *
     * @param opts
     * @returns {Promise<any>}
     */
    callNative: function ({
                              fnName = '', params = {}, duration
                          }) {
        if (this.IS_APP_ENV) {
            // 由于 iOS 在接收 params 时使用了两次 decode, 所以这里需要针对 iOS encode 两次
            if (device().isiOS) {
                params = encodeURIComponent(JSON.stringify(params))
            }
            return this._callNative(fnName, params, duration)
        } else {
            return new Promise((resolve, rejecet) => {
                rejecet(new Error(`Browser can't call ${fnName}`))
            })
        }
    },
    /*addNoticeListener: (function () {
        let listenerMap = {}
        document.addEventListener('NATIVE_NOTICE', (funName, ...args) => {
            const list = listenerMap[funName]
            Array.isArray(list) && list.forEach((fn) => {
                typeof fn === "function" && fn(...args)
            })
        }, false)
        return function (funName, fun) {
            if (typeof funName !== 'string' || typeof fun !== 'function') {
                return
            }
            listenerMap[funName] = listenerMap[funName] || []
            listenerMap[funName].push(fun)
        }
    })(),*/
    addComponentReactNoticeListener: (function () {

        let generateComponentReactActionName = function ({expectedAction, expectCmptId, expectedType}, info) {
            sessionStorage.setItem(Date.now(), info + JSON.stringify({expectedAction, expectCmptId, expectedType}))
            let actionNameTemp
            switch (expectedAction) {
                case CR.COMPONENT_REACT_TYPE.VIDEO_TEMPLATE_LEGACY_LOAD_STATE_CHANGED:
                    actionNameTemp = `action_${expectedAction}$id_${expectCmptId}`
                    break
                case CR.COMPONENT_REACT_TYPE.VIDEO_TEMPLATE_LEGACY_CLOSE_BUTTON_CLICKED:
                    actionNameTemp = `action_${expectedAction}$id_${expectCmptId}`
                    break
                case CR.COMPONENT_REACT_TYPE.VIDEO_TEMPLATE_LEGACY_NEED_CALL_DEVELOPER:
                    actionNameTemp = `action_${expectedAction}$id_${expectCmptId}$type_${expectedType}`
                    break
                default:
                    console.warn('匹配 componentReact action 枚举失败, 请确认')
                    break
            }
            // console.warn('生成的 actionName', actionNameTemp, {expectedAction, expectCmptId, expectedType})
            return actionNameTemp
        }

        let listenerMap = {}
        window.componentReactNoticeListener = listenerMap
        document.addEventListener('componentReact', (res) => {
            console.warn('=-= componentReact 事件入口 - 收到 SDK componentReact 通知!!!!!!', res.param)
            let {action, cmpt, data} = res && res.param

            if (typeof action === 'undefined' || typeof cmpt === 'undefined' || typeof data === 'undefined') {
                console.warn('componentReact 事件的 param 入参不合法')
                return false
            }

            let actionName = generateComponentReactActionName({
                expectedAction: action,
                expectCmptId: cmpt.id,
                expectedType: data.type
            }, 'trigger lis')
            if (typeof actionName === 'undefined') {
                console.warn('=-= 生成 actionName 失败')
            }
            const callbackList = listenerMap[actionName]
            console.log(`=-= ----- 当前将要触发的事件标识:`, {actionName, callbackList}
                , `=-= ----- 当前 SDK 传入的数据: `, {action, cmpt, data}
                , `=-= ----- 当前已注册的事件列表`, Object.keys(listenerMap))
            if (Array.isArray(callbackList)) {
                callbackList.forEach((fn) => {
                    if (typeof fn === "function") {
                        fn({action, cmpt, data})
                        console.warn('=-= componentReact 事件出口 - 事件标识对应的 function 被触发!!!', {action, cmpt, data})
                    } else {
                        console.warn('=-= 当前不是 function')
                    }
                })
            } else {
                console.log('=-= 没有匹配到该 actionName 对应的 callback: ', {
                    actionName,
                    callbackList: Object.keys(listenerMap)
                })
            }
        }, false)
        return function (actionNameConfig, actionCallback) {
            if (typeof actionNameConfig !== 'object' || typeof actionCallback !== 'function') {
                console.log('=-= addComponentReactNoticeListener: 入参格式不符合要求, 无法注册事件到队列中', {
                    actionNameConfig,
                    actionCallback
                })
                return
            }
            let actionName = generateComponentReactActionName(actionNameConfig, 'add lis') // actionNameConfig = {expectedAction, expectCmptId, expectedType}
            listenerMap[actionName] = listenerMap[actionName] || []
            listenerMap[actionName].push(actionCallback)
            console.log(`=-= ${actionName} 已加入监听, 当前监听队列: `, Object.keys(listenerMap))
        }
    })(),
    /*onNativeCall: function (funName, fun) {
        if (typeof funName !== 'string' || typeof fun !== 'function') {
            return
        }
        this.addNoticeListener(funName, fun)
        document.addEventListener(funName, () => {
            let event = document.createEvent('NATIVE_NOTICE')
            document.dispatchEvent(event)
        }, false)

    },*/
    addEventListener: function (funName, fun, options=false) {
        if (typeof funName !== 'string' || typeof fun !== 'function') {
            return
        }
        document.addEventListener(funName, fun, options)
    },
    /**
     * 为组件添加监听事件
     * @params componentId | Number 组件id
     * @params eventName | String  事件名称
     * @params fun | Function 回调函数
     */
    addComponentEventListener: (function(){
        let listenerMap = {}
        return function (componentId, eventName, fun) {
            if (typeof eventName !== 'string' || typeof fun !== 'function') {
                console.warn('addComponentEventListener:绑定参数不正确')
                return
            }

            //判断eventName是否被注册过监听，没有的话注册一个关于这个eventName的监听
            if(!listenerMap[eventName]){
                listenerMap[eventName] = {}

                //eventName监听被触发后，查找到eventName下具体的匹配的组件id的监听列表，然后顺序执行触发
                document.addEventListener(eventName, (event)=>{
                    console.log('##监听到事件:',eventName,event)
                    const {id, data} = event.param
                    const listenerCmpts = listenerMap[eventName] || []
                    let listenerList = []
                    for(let _componentId in listenerCmpts){
                        if(id === _componentId){
                            listenerList = listenerMap[eventName][_componentId]
                            listenerList.forEach(listener=>{
                                listener(data)
                            })
                            break
                        }
                    }
                }, false)
            }
            if(!listenerMap[eventName][componentId]){
                listenerMap[eventName][componentId] = []
            }
            //将handle添加到对应的监听列表中
            listenerMap[eventName][componentId].push(fun)
        }
    })(),



    /*addComponentEventListener: function (componentId, eventName, fun) {
        console.log('eventName:',eventName,'   componentId',componentId)
        document.addEventListener(eventName, (event)=>{
            console.log('触发 eventName:',eventName,'   event',event.param,componentId, typeof componentId, event.param.data.id, typeof event.param.data.id, event.param.data.id===componentId)
            const {id, data} = event.param
            if(id === componentId){
                console.log('触发2 eventName:',eventName,'   event',event.param,id, typeof id)
                fun(data)
            }
        }, false)
    },*/
}

export default jsBridge
